import request from '../request.js'

// 根据ID获取JSON格式项目详情及结构树 --- 王开国
const getStructureData = function (data) {
    return request({
        url: 'busProContract/getProjectTreeJsonById',
        //url: 'busTrackAudit/auditEcho',
        method: 'post',
        data
    })
}

// 新增结构节点 --- 王开国
const addTreeNode = function (data) {
    return request({
        url: 'busProContractTree/addProjectStructures',
        method: 'post',
        data
    })
}

// 删除单位工程节点 --- 王开国
const delTreeNode = function (data) {
    return request({
        url: 'busProContractTree/deleteProjectStructures',
        method: 'post',
        data
    })
}

// 编辑结构节点 --- 王开国
const editTreeNode = function (data) {
    return request({
        url: 'busProContractTree/editProjectStructures',
        method: 'post',
        data
    })
}

// 项目基本信息编辑项目信息 --- 叶凡
const updateBusProContract = function (data) {
    return request({
        url: 'busProContract/updateBusProContract',
        method: 'post',
        data
    })
}

// 指标分析-页面回显 --- 叶凡
const getTargetAnalysis = function (data) {
    return request({
        url: 'busProContract/getTargetAnalysis',
        method: 'post',
        data
    })
}


// 造价总览--获取项目六算各阶段的价格信息 --- 叶凡
const getProjectCost = function (data) {
    return request({
        url: 'busCostDetail/getProjectCost',
        method: 'post',
        data
    })
}


// 指标分析模块-按条件筛选项目类型相同的项目列表 --- 叶凡
const selectProjectList = function (data) {
    return request({
        url: 'busProContract/selectProjectList',
        method: 'post',
        data
    })
}

// 六算分析表--导出Excle --- 叶凡
const sixCostExportExcle = function (data) {
    return request({
        url: 'busProContract/sixCostExportExcle',
        method: 'post',
        data
    })
}

// 项目结构 --- 同步数据
const doSyncData = function (data) {
    return request({
        url: 'analysisDynamicBlock/synchroStructureInformation',
        method: 'post',
        data
    })
}

// 项目结构 --- 获取xml （郑志会）
const xmlToStructure = function (data) {
    return request({
        url: 'busProContractTree/treeAnalysisFile',
        method: 'post',
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        },
        data
    })
}

// 项目结构 --- 重构的 保存编辑 （郑志会）
const saveAndeditProjectTree = function (data) {
    return request({
        url: 'busProContractTree/saveAndeditProjectTree',
        method: 'post',
        data
    })
}

// 根据ID获取签证结构树 --- yef
const getVisaStructure = function (data) {
    return request({
        url: 'busProContractTree/getVisaStructure',
        method: 'post',
        data
    })
}

// 解析签证xml 文件 --- 郑志会
const parseVisaXml = function (data) {
    return request({
        url: 'visaCostDetail/visaCostAnalysisFile',
        method: 'post',
        data
    })
}

// 签证价格基本信息-最终保存接口 --- 郑志会
const visaCostSave = function (data) {
    return request({
        url: 'visaCostDetail/visaCostSave',
        method: 'post',
        data
    })
}

export {
    addTreeNode,
    delTreeNode,
    editTreeNode,
    getProjectCost,
    getVisaStructure,
    getStructureData,
    selectProjectList,
    getTargetAnalysis,
    sixCostExportExcle,
    updateBusProContract,
    doSyncData,
    xmlToStructure,
    saveAndeditProjectTree,
    parseVisaXml,
    visaCostSave
}